import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import LoadingButton from "components/shared/LoadingButton";
import close from "Assets/images/cross_icon.png";
// css
import styles from "./index.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useCreateMultipleGoalsMutation, useGetAssessmentGoalsListQuery } from "store/services/clients/reports-v2/schoolReports";
import LoadingIndicator from "components/shared/LoadingIndicator";
import DatePicker from "react-datepicker";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CstmPagination } from "components/Common/Common";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";

const AddTreatmentPop = ({ showPopup, closePopup, refetchData, handleSubmitReport }) => {
  const { setFieldValue, values } = useFormikContext();
  const [selectedGoals, setSelectedGoals] = useState([]);
  const { reportId, clientType, clientId } = useParams();
  const [dateFilter, setDateFilter] = useState({ start_date: null, end_date: null })
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const shouldSkip =
    (dateFilter?.start_date && !dateFilter?.end_date) ||
    (!dateFilter?.start_date && dateFilter?.end_date);

  const { data: assessmentGoals, isLoading: assessmentGoalsLoading, isFetching: assessmentGoalFetching } = useGetAssessmentGoalsListQuery({ limit: pageSize, page: currentPage, clientId, start_date: dateFilter?.start_date, end_date: dateFilter?.end_date }, { skip: shouldSkip })
  const totalRecords = assessmentGoals?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [submitCreateGoal, { isLoading }] = useCreateMultipleGoalsMutation();

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleSubmit = async () => {
    try {
      const data = cloneDeep(values)
      data.saveForLater = true
      data.notSavedFromButton = true
  
      if (handleSubmitReport && typeof handleSubmitReport == "function") {
        await handleSubmitReport(data);
        setFieldValue('notSavedFromButton', false)
      }
    } catch (error) {
      console.log('error', error)
    }
    try {

      // format payload
      const payload = {
        goals: selectedGoals?.map((item) => (
          {
            area_id: item?.area_id,
            goal_id: item?.goal_id,
            context_id: item?.context_id,
            goal_description: item?.goal_description,
            status: 184,
            discipline_id: item?.discipline_id,
          }
        ))

      }

      let response = await submitCreateGoal({
        assessmentId: reportId,
        data: payload,
        clientType
      });

      if (typeof (refetchData) === "function") {
        await refetchData();
        setSelectedGoals([])
        closePopup();
      }
      if (response?.data) {
        successMessageToast(response?.data?.message)
        // closePopup();
        // if (typeof submitCallback === "function") submitCallback(response?.data);
      }
    } catch (err) {
      console.error("Error creating goal", err);
    }
  }


  const column = [
    {
      head: <div style={{ fontSize: '12px' }}>{"AREA"}</div>,
      accessor: "area",
      isComponent: true,
      component: (item, ind) => (
        <>
          <div className="d-flex align-items-center gap-2">
            <div className="session-input-radio text-area-report">

              <div className="radio-inputs">
                <div className="d-flex align-items-center py-1">
                  <input
                    type="checkbox"
                    // id={"table-radio"}
                    // value={item?.id}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedGoals(prev => [...prev, item])
                      } else {
                        setSelectedGoals(prev => prev.filter(i => i?.id !== item?.id))
                      }
                    }}
                    checked={selectedGoals?.some(i => i?.id === item?.id)}
                  />
                  {/* <label className={textMuted && "text-muted"} style={{ marginLeft: "8px", ...labelStyles }}>{option.label || option.name}</label> */}
                </div>
              </div>
            </div>
            <h6 className="m-0" style={{ color: "#315D99", fontSize: 14 }}>{item?.assesmentGoalDisciplineArea?.name}</h6>
          </div>
        </>
      ),
    },
    {
      head: <div style={{ fontSize: '12px' }}>{"GOAL"}</div>,
      accessor: "goal",
      isComponent: true,
      component: (item, ind) => (
        <>
          <h6 className="m-0" style={{ color: "#315D99", fontSize: 14 }}>{item?.assesmentGoalDetail?.title}</h6>
        </>
      ),
    },
    {
      head: <div style={{ fontSize: '12px' }}>{"CONTEXT"}</div>,
      accessor: "context",
      isComponent: true,
      component: (item, ind) => (
        <>
          <h6 className="m-0" style={{ color: "#315D99", fontSize: 14 }}>{item?.assesmentGoalContext?.context}</h6>
        </>
      ),
    },
    {
      head: <div style={{ fontSize: '12px' }}>{"DATE OF REPORT"}</div>,
      accessor: "lastUsed",
      isComponent: true,
      component: (item, ind) => (
        <div>{moment(item?.assesmentGoalAssesment?.screening_date).format("MMM DD, YYYY")}</div>
      ),
    },
  ];

  return (
    <Modal
      show={showPopup}
      className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop add-new-assesment`}
      onHide={closePopup}
      backdrop="static"
      keyboard={false}
      centered
      size="xl"
    >
      <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
        <div className="reports-v2">
          <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
            <h6 className="mb-0 section-title border-bottom-0 text-uppercase" style={{ color: "#315D99" }}>ADD AN AREA</h6>
            <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
          </div>
          <Row className="mb-2">
            {/* <Col lg="6"></Col> */}
            <Col lg="2">
              <DatePicker
                placeholder="e.g John"
                className="w-100 py-2"
                portalId={"root"}
                autocomplete="off"
                onChange={(e) => {
                  const formattedDate = moment(e).format("YYYY-MM-DD");
                  setDateFilter(prev => ({ ...prev, start_date: formattedDate }))
                }}
                placeholderText='Start Date'
                icon={icon}
                showIcon
                onKeyDown={e => e.preventDefault()}
                autoComplete='off'
                showPopperArrow={false}
                dateFormat="MMMM d, yyyy"
                showYearDropdown
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                value={dateFilter?.start_date}
                maxDate={dateFilter?.end_date}
                isClearable

              // value={field?.value ? moment(field?.value, "YYYY-MM-DD").format("DD/MM/YYYY") : ""} 
              // withPortal
              />
            </Col>
            <Col lg="2">
              <DatePicker
                className="w-100 py-2"
                portalId={"root"}
                autocomplete="off"
                // {...field}
                // {...props}
                onChange={(e) => {
                  const formattedDate = moment(e).format("YYYY-MM-DD");
                  setDateFilter(prev => ({ ...prev, end_date: formattedDate }))
                }}
                placeholderText='End Date'
                icon={icon}
                isClearable
                showIcon
                onKeyDown={e => e.preventDefault()}
                autoComplete='off'
                showPopperArrow={false}
                dateFormat="MMMM d, yyyy"
                showYearDropdown
                scrollableYearDropdown
                minDate={dateFilter?.start_date}
                yearDropdownItemNumber={100}
                value={dateFilter?.end_date}

              // value={field?.value ? moment(field?.value, "YYYY-MM-DD").format("DD/MM/YYYY") : ""} 
              // withPortal
              />
            </Col>
            <Col lg="1">
              <LoadingButton
                type="button"
                style={{ background: "#fff", border: "1px solid #315D99", color: "#315D99", padding: "5px 30px", margin: 0 }}
                onClick={() => setDateFilter({ start_date: null, end_date: null })}
                className="blue-discharge-screen-btn"
                disabled={assessmentGoalsLoading || isLoading}
              >
                {"Clear"}
              </LoadingButton>
            </Col>
          </Row>
          <div className="mt-3">
            <div style={{ border: "1px solid #9a9797", padding: "10px" }} className="">
              {
                assessmentGoalsLoading ? <LoadingIndicator /> :
                  <>
                    {assessmentGoalFetching && <LoadingOverlay />}
                    <TableLayout
                      data={assessmentGoals?.records || []}
                      column={column}
                      height={"275px"}
                    />
                    <CstmPagination
                      totalPages={totalPages}
                      className={'paginationV2'}
                      activePage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  </>
              }
            </div>
          </div>
        </div>
        <div className="btnWrpper mt-2 gap-2 text-end d-flex justify-content-end">
          <LoadingButton
            type="button"
            style={{ background: "#fff", border: "1px solid #315D99", color: "#315D99", padding: "11px 30px" }}

            onClick={() => closePopup()}
            className="blue-discharge-screen-btn"
            disabled={assessmentGoalsLoading || isLoading}
          >
            {"Cancel"}
          </LoadingButton>
          <LoadingButton
            type="button"
            style={{ background: "#315D99", border: "1px solid #315D99", color: "#fff", padding: "11px 30px" }}
            className="blue-discharge-screen-btn"
            onClick={() => handleSubmit()}
            disabled={assessmentGoalsLoading || isLoading}
            isLoading={isLoading}
          >
            {"Add to Report"}
          </LoadingButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddTreatmentPop;


const TableLayout = ({ column, data, url, showHeader = true, noDataMsg = "Data not found", state, handleRowClick, height }) => {
  const navigate = useNavigate();
  return (
    <div className="favorite-goal-wrapper table_height" style={{ height: height || "calc(100vh - 220px)" }}>
      <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
        <table className={`${styles.table} table`}>
          {showHeader && (
            <thead>
              <tr className="">
                {column &&
                  column.length > 0 &&
                  column.map((item, key) => (
                    <>
                      <th className="proxima" style={{ borderBottom: "2px solid #315D99", fontWeight: "100" }}>
                        {item.head}
                      </th>
                    </>
                  ))}
              </tr>
            </thead>
          )}
          <tbody>
            {data && data?.length > 0 ? (
              data.map((data, columnkey) => {
                return (
                  <tr
                    className={`${url && "cursor-pointer"}`}
                    onClick={(e) => {
                      url && navigate(`${url}/${data.id}`, { state });
                      (handleRowClick && typeof handleRowClick == "function") && handleRowClick(data);
                    }}
                  >
                    {column &&
                      column.length > 0 &&
                      column.map((item, key) => {
                        if (item.component) {
                          return (
                            <td className="proxima" style={{ fontWeight: "100" }}>
                              {item.component(data, columnkey, data)}
                            </td>
                          );
                        }

                        return (
                          <td className="proxima-regular">{data[item?.accessor] || "--"}</td>
                        );
                      })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={column?.length || 1} className="text-center">
                  {noDataMsg}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const icon =
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2980_12553" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2980_12553)">
      <path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z" fill="#071E3E" />
    </g>
  </svg>